export const fuseOptions = {
    includeScore: true,
    shouldSort: true,
    findAllMatches: true,
    ignoreLocation: true,
    keys: ['text'],
};
